// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueDropdownGroup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Filter value dropdown component
 */

import { propTypes as MobxPropTypes } from 'mobx-react';
import React, { Component, PropTypes } from 'react';
import Dropdown from 'share/components/controls/Izenda.DropDown';
import { isEmpty, invokeArgs, get } from 'lodash/fp';

export default class OperatorValueDropdownGroup extends Component {
  static propTypes = {
    filterInfo: PropTypes.object.isRequired,
    filterSource: MobxPropTypes.arrayOrObservableArray.isRequired,
    labelField: PropTypes.string.isRequired,
    valueField: PropTypes.string.isRequired,
    groupBy: PropTypes.string.isRequired
  };

  componentWillMount() {
    const { filterSource, configField, store } = this.props;
    isEmpty(filterSource) && invokeArgs('getOperatorValueSource', [configField], store);
  }

  onChange = e => {
    this.props.onChange([e.value]);
  };

  render() {
    const props = this.props;
    const filterInfo = props.filterInfo || {};
    let valueField = props.valueField;
    const renderInContainer = props.renderInContainer;

    // For In Time Period type, use customId field
    if (get('sourceType', filterInfo) === 'inTimePeriod') {
      valueField = 'customId';
    }

    return (
      <Dropdown
        options={props.filterSource}
        onChange={this.onChange}
        value={filterInfo.value && filterInfo.value[0]}
        labelField={props.labelField}
        valueField={valueField}
        groupBy={props.groupBy}
        blankOption
        blankOptionText={'...'}
        disabled={props.disabled}
        renderInContainer={renderInContainer}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/OperatorValue/Izenda.OperatorValueDropdownGroup.jsx